import * as React from 'react';
import { useGanttViewTasksContext } from '../context/GanttViewContext';
import { STORE_ACTION } from './useDictionaryStore';
/** @hidden */
export var useGanttTask = function (dataItem, id, ref, taskElementRef) {
    var taskRef = React.useRef(null);
    var _a = useGanttViewTasksContext(), dispatchTaskRef = _a[1];
    React.useImperativeHandle(taskRef, function () { return ({ element: taskElementRef.current, dataItem: dataItem }); });
    React.useImperativeHandle(ref, function () { return taskRef.current; });
    React.useLayoutEffect(function () {
        var target = taskRef.current;
        if (target) {
            dispatchTaskRef({
                type: STORE_ACTION.add,
                itemRef: target,
                id: id
            });
            return function () {
                dispatchTaskRef({
                    type: STORE_ACTION.remove,
                    itemRef: target,
                    id: id
                });
            };
        }
    });
};
